import CryptoJS from "crypto-js";

/**
 * 加密方法
 * @param data
 * @returns {string}
 */
export function encrypt(data) {
    const str = CryptoJS.MD5(data).toString();
    return str;
}



// WEBPACK FOOTER //
// ./src/util/md5.js